import { Card, Flex, Progress, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { getProgressPercent } from '../helpers';
import { EvidenceProgress } from 'api/brokerCases/types';
import { TypedFormatMessageFn } from 'types/intl';

export interface IEvidenceProgressCardProps {
  progress: EvidenceProgress;
}

export const EvidenceProgressCard = ({ progress }: IEvidenceProgressCardProps) => {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();
  const { totalCount, completedCount } = progress;
  const percent = getProgressPercent(completedCount, totalCount);

  return (
    <Card className='rounded-2xl border-0 [&_.ant-card-body]:p-6'>
      <Flex className='gap-6' align='center'>
        <div className='relative h-20 w-20 shrink-0'>
          <Progress type='circle' percent={percent} size={80} format={() => null} strokeColor='#05DF72' />
          <div className='absolute inset-0 flex items-center justify-center'>
            <Typography.Text className='text-center text-base font-bold leading-6'>
              {formatMessage({ id: 'evidence.progressCard.count' }, { completedCount, totalCount })}
            </Typography.Text>
          </div>
        </div>
        <Flex vertical className='gap-1'>
          <Typography.Text className='text-lg font-bold leading-8'>
            {formatMessage({ id: 'evidence.progressCard.title' })}
          </Typography.Text>
          <Typography.Text className='text-sm font-normal leading-5 text-gray-500'>
            {formatMessage({ id: 'evidence.progressCard.description' })}
          </Typography.Text>
        </Flex>
      </Flex>
    </Card>
  );
};
